import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Register the semantic font-size tokens (defined in tailwind.preset.cjs) so
// twMerge classifies them as font-size utilities and dedupes them against the
// built-in scale, e.g. cn('text-2xl', 'text-h3') keeps only 'text-h3'.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'h1', 'h2', 'h3', 'kpi', 'body', 'caption'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
